import { render, staticRenderFns } from "./LogoPausentaste.vue?vue&type=template&id=b6e5a37a&scoped=true&"
import script from "./LogoPausentaste.vue?vue&type=script&lang=js&"
export * from "./LogoPausentaste.vue?vue&type=script&lang=js&"
import style0 from "./LogoPausentaste.vue?vue&type=style&index=0&id=b6e5a37a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e5a37a",
  null
  
)

export default component.exports